import React from 'react';
import {
  Form, Checkbox, Spin, Icon,
} from 'antd';
import {
  Box,
} from '../../shared/components';
import InlineCard from '../components/InlineCard';


export default function ClientesTab({
  clientes, form, noConformidades, onChangeClientesSeleccionados, clientesSeleccionados,
}) {
  const { getFieldDecorator } = form;
  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  let content = '';
  const { listado, loading } = clientes;
  const { seleccionada } = noConformidades;
  let { clientes: clientesArray } = seleccionada;
  clientesArray = (typeof (clientesArray) !== 'undefined') ? clientesArray : [];

  if (!Array.isArray(clientesArray)) {
    clientesArray = clientesArray.split(',');
  }

  for (let i = 0; i < clientesArray.length; i += 1) {
    if (clientesArray[i] !== undefined) {
      clientesArray[i] = parseInt(clientesArray[i], 10);
    }
  }

  content = (
    <InlineCard
      headerText="CLIENTES"
      content={(
        <Box px={5} py={3}>
          <Spin indicator={antIcon} spinning={loading} size="large">
            {listado.map(item => (
              <Form.Item key={item.id}>
                {getFieldDecorator(`clientes[${item.id}]`, {
                  initialValue: (clientesArray.indexOf(item.id) >= 0) || (clientesSeleccionados.filter(valor => valor === item.id).length > 0),
                  valuePropName: 'checked',
                })(
                  <Checkbox idCliente={item.id} onChange={e => onChangeClientesSeleccionados(e)}>{item.razon}</Checkbox>,
                )}
              </Form.Item>
            ))}
          </Spin>
        </Box>
      )}
    />
  );

  return content;
}
